/**
 * User-facing message for a failed POST /api/billing/charge-saved-card.
 *
 * The backend distinguishes the outcome via status code:
 * - 402: the issuer declined the card — retrying the same card won't help.
 * - 409: an identical charge is already being processed (duplicate guard) —
 *   the user must wait, NOT re-register the card or retry immediately.
 * - anything else: unexpected server error, generic guidance.
 */
export function chargeSavedCardErrorMessage(status: number): string {
  if (status === 402) {
    return "Cartão recusado pela operadora. Verifique os dados do cartão ou tente outro método de pagamento.";
  }
  if (status === 409) {
    return "Já existe uma recarga idêntica em processamento. Aguarde alguns instantes e confira o histórico antes de tentar novamente.";
  }
  return "Não conseguimos cobrar com o cartão selecionado. Por favor, tente (re)cadastrar o cartão.";
}
